import * as actionTypes from './actionTypes';
import { startLoading, endLoading, errorLoading, getCart, getCartRequest, getCartFailure, setFormattedOrderItems, getCartSuccess, getSpeedyDetails } from './cartActions';
import { getEnabledShippingModes, setSelectedShippingMode } from './shippingModesActions';
import { getAddress, setAddress, getAllBillingAddresses } from './addressActions';
import urlList from '@utils/urlList';
import axios from 'axios';
import * as actions from '@redux-actions/';
import { handleHTTPError } from '@utils/utils';
import { getMockFaq, getMockPerson } from '@utils/mockUtils';
import { getEspot } from '@utils/services';

export {
    saveConfig,
    setModal,

    startLoading,
    endLoading,
    errorLoading,

    populateCart,

    getCart,
    getCartRequest,
    getCartSuccess,
    getCartFailure,
    setFormattedOrderItems,

    getEnabledShippingModes,
    setSelectedShippingMode,

    getAddress,
    setAddress,
    getAllBillingAddresses,

    setIsMobile,
    setFaq,
    setUpsellDetails,

    setOrderId,
    setShowSessionModal,
    setGenericErrorModal,

    setEmail,
    setShowPromoCodeFeedback,
    setPerson,
    setInsurance,
    setInsuranceError,

    getEspotTyp,
    setDisableNavigation,

    getEspotFooter,
    setClientSideNavigation,

    setOpenModalBoss,
    setPhysicalStores,
    setRadius,
    setSelectedStore,
    setClickedStore,
    setIsBossSelected,
    setLatitude,
    setLongitude,
    setErrorBoss,

    getSpeedyDetails,
    setSpeedyDetails,
}

const saveConfig = (config) => {
    return {
        type: actionTypes.SAVE_CONFIG,
        config
    }
}

const setModal = (openModal) => {
    return {
        type: actionTypes.OPEN_MODAL,
        openModal
    }
}

const populateCart = (mockRequests: boolean, hostname: string, data?: any) => {
    return (dispatch, getState) => {
        Promise.all([
            dispatch(getCart(mockRequests, hostname)),
            dispatch(getEnabledShippingModes(mockRequests, hostname))
        ])
        .then(() => {
            if(
                !!getState().cart.cart && 
                !!getState().cart.cart.orderItem &&
                getState().cart.cart.orderItem.length > 0 &&
                !!getState().cart.enabledShippingModes &&
                getState().cart.enabledShippingModes.length > 0
            ) {
                const item = getState().cart.enabledShippingModes.find(item => item.shipModeCode === getState().cart.cart.orderItem[0].shipModeCode);
                dispatch(setSelectedShippingMode(item));
                dispatch(setPerson(hostname, mockRequests));
                dispatch(setSpeedyDetails(hostname, getState().cart.cart.orderId))
                if(!!data) data.callFromComponentToGl.calculateInsuranceOnLoading();
            }  else {
                dispatch(errorLoading())
            }
        })
        
    }
}

const setSpeedyDetails = (hostname: string, orderId: string) => {
    return (dispatch, getState) => {
        Promise.all([
            dispatch(getSpeedyDetails(hostname, orderId))
        ]).then(() => {
            if(!!getState().cart.speedyOrderDetails){
                console.log("Speedy Order Detail Successful")
            } else {
                console.error("Error retrieving speedy order detail")
            }
        })
    }
}

const setIsMobile = (isMobile) => {
    return {
        type: actionTypes.SET_IS_MOBILE,
        isMobile
    }
}

const setFaq = (hostname, mockRequests) => {
    return (dispatch) => {
        const url = hostname + urlList['SET_FAQ'] + '?nocache=' + new Date().getTime();

        dispatch(startLoading());
        (mockRequests === true ?
            getMockFaq() :
            axios({
                url,
                method: 'GET',
                withCredentials: true,
                headers: {
                    'Cache-Control': 'no-cache',
                    'Pragma': 'no-cache',
                    'Expires': '0',
                }
            })
        )
        .then((res: any) => {
            if(!!res.data && !!res.data.MarketingSpotData && !!res.data.MarketingSpotData[0] &&
                !!res.data.MarketingSpotData[0].baseMarketingSpotActivityData &&
                !!res.data.MarketingSpotData[0].baseMarketingSpotActivityData[0] &&
                !!res.data.MarketingSpotData[0].baseMarketingSpotActivityData[0].marketingContentDescription &&
                !!res.data.MarketingSpotData[0].baseMarketingSpotActivityData[0].marketingContentDescription[0] &&
                !!res.data.MarketingSpotData[0].baseMarketingSpotActivityData[0].marketingContentDescription[0].marketingText
            ) {
                dispatch(setFaqSuccess(res.data.MarketingSpotData[0].baseMarketingSpotActivityData[0].marketingContentDescription[0].marketingText.replace("[environmentDomain]", config.hostname+'/gl-us')))
            } else {
                console.log('>>> Espot Faq empty')
            }
        })
        .catch((err) => {
            console.error('>>> Set faq => error status:', err.status, ', error: ', err);
            handleHTTPError(dispatch, actions, err.response);
            dispatch(setFaqFailure());
        }) 
    }
}

const setUpsellDetails = (hostname) => {
    return (dispatch) => {
        getEspot(hostname, 'X_Cart_Upsell_Details').then((res: any) => {
	        if (!!res) {
                dispatch(setUpsellDetailsSuccess(res));
	        } else {
                console.log('>>> Espot X_Cart_Upsell_Details empty')
            }
	      }).catch(err => {
	        console.error('>>> Get Espot X_Cart_Upsell_Option => error status:', err.status, ', error: ', err);
	        handleHTTPError(dispatch, actions, err);
            dispatch(setUpsellDetailsFailure());
	      });
    }
}

const setFaqSuccess = (faq) => {
    return {
        type: actionTypes.SET_FAQ_SUCCESS,
        faq
    }
}

const setFaqFailure = () => {
    return {
        type: actionTypes.SET_FAQ_FAILURE
    }
}

const setUpsellDetailsSuccess = (upsellDetails) => {
    return {
        type: actionTypes.SET_CART_UPSELL_DETAILS_SUCCESS,
        upsellDetails
    }
}

const setUpsellDetailsFailure = () => {
    return {
        type: actionTypes.SET_CART_UPSELL_DETAILS_FAILURE
    }
}

const setOrderId = (orderId) => {
    return {
        type: actionTypes.SET_ORDER_ID,
        orderId
    }
}

const setShowSessionModal = (showSessionModal) => {
    return {
        type: actionTypes.SET_SHOW_SESSION_MODAL,
        showSessionModal
    }
}

const setGenericErrorModal = (showGenericErrorModal, modalErrorText) => {
    return {
        type: actionTypes.SET_SHOW_GENERIC_ERROR_MODAL,
        showGenericErrorModal,
        modalErrorText
    }
}

const setEmail = (email) => {
    return {
        type: actionTypes.SET_EMAIL,
        email
    }
}

const setShowPromoCodeFeedback = (showPromoCodeFeedback) => {
    return {
        type: actionTypes.SET_SHOW_PROMO_CODE_FEEDBACK,
        showPromoCodeFeedback
    }
}

const setPerson = (hostname, mockRequests) => {
    return (dispatch) => {
        const url = hostname + urlList['SET_PERSON'] + '?nocache=' + new Date().getTime();

        dispatch(startLoading());
        (mockRequests === true ?
            getMockPerson()
        : axios({
            url,
            method: 'GET',
            withCredentials: true,
            headers: {
                'Cache-Control': 'no-cache',
                'Pragma': 'no-cache',
                'Expires': '0',
            }
        }))
        .then((res: any) => {
            dispatch(setPersonSuccess(res.data))
        })
        .catch((err) => {
            console.error('>>> Set person => error status:', err.status, ', error: ', err);
            handleHTTPError(dispatch, actions, err.response);
        }) 
    }
}

const setPersonSuccess = (person) => {
    return {
        type: actionTypes.SET_PERSON,
        person
    }
}

const setInsurance = (insurance) => {
    return {
        type: actionTypes.SET_INSURANCE,
        insurance
    }
}

const getEspotTyp = (hostname) => {
    return (dispatch) => {
        const url = hostname + urlList['GET_ESPOT_TYP'] + '?nocache=' + new Date().getTime();

        dispatch(startLoading());
        axios({
            url,
            method: 'GET',
            withCredentials: true,
            headers: {
                'Cache-Control': 'no-cache',
                'Pragma': 'no-cache',
                'Expires': '0',
            }
        })
        .then((res: any) => {
            if(!!res.data && !!res.data.MarketingSpotData && !!res.data.MarketingSpotData[0] &&
                !!res.data.MarketingSpotData[0].baseMarketingSpotActivityData &&
                !!res.data.MarketingSpotData[0].baseMarketingSpotActivityData[0] &&
                !!res.data.MarketingSpotData[0].baseMarketingSpotActivityData[0].marketingContentDescription &&
                !!res.data.MarketingSpotData[0].baseMarketingSpotActivityData[0].marketingContentDescription[0] &&
                !!res.data.MarketingSpotData[0].baseMarketingSpotActivityData[0].marketingContentDescription[0].marketingText
            ) {
                dispatch(getEspotTypSuccess(res.data.MarketingSpotData[0].baseMarketingSpotActivityData[0].marketingContentDescription[0].marketingText.replace("[environmentDomain]", config.hostname+'/gl-us')))
            } else {
                console.log('>>> Espot Typ empty')
            }
            
        })
        .catch((err) => {
            console.error('>>> Espot Typ => error status:', err.status, ', error: ', err);
            handleHTTPError(dispatch, actions, err.response);
            dispatch(getEspotTypFailure());
        }) 
    }
}

const getEspotTypSuccess = (espotTyp) => {
    return {
        type: actionTypes.GET_ESPOT_TYP_SUCCESS,
        espotTyp
    }
}

const getEspotTypFailure = () => {
    return {
        type: actionTypes.GET_ESPOT_TYP_FAILURE
    }
}

const setDisableNavigation = (disableNavigation) => {
    return {
        type: actionTypes.SET_DISABLE_NAVIGATION,
        disableNavigation
    }
}

const setInsuranceError = (insuranceError) => {
    return {
        type: actionTypes.SET_INSURANCE_ERROR,
        insuranceError
    }
}

const getEspotFooter = (hostname) => {
    return (dispatch) => {
        const url = hostname + urlList['GET_ESPOT_FOOTER'] + '?nocache=' + new Date().getTime();

        dispatch(startLoading());
        axios({
            url,
            method: 'GET',
            withCredentials: true,
            headers: {
                'Cache-Control': 'no-cache',
                'Pragma': 'no-cache',
                'Expires': '0',
            }
        })
        .then((res: any) => {
            if(!!res.data && !!res.data.MarketingSpotData && !!res.data.MarketingSpotData[0] &&
                !!res.data.MarketingSpotData[0].baseMarketingSpotActivityData &&
                !!res.data.MarketingSpotData[0].baseMarketingSpotActivityData[0] &&
                !!res.data.MarketingSpotData[0].baseMarketingSpotActivityData[0].marketingContentDescription &&
                !!res.data.MarketingSpotData[0].baseMarketingSpotActivityData[0].marketingContentDescription[0] &&
                !!res.data.MarketingSpotData[0].baseMarketingSpotActivityData[0].marketingContentDescription[0].marketingText
            ) {
                dispatch(getEspotFooterSuccess(res.data.MarketingSpotData[0].baseMarketingSpotActivityData[0].marketingContentDescription[0].marketingText.replace("[environmentDomain]", config.hostname+'/gl-us')))
            } else {
                console.log('>>> Espot Footer empty')
            }
        })
        .catch((err) => {
            console.error('>>> Espot Footer => error status:', err.status, ', error: ', err);
            handleHTTPError(dispatch, actions, err.response);
            dispatch(getEspotFooterFailure());
        }) 
    }
}


const getEspotFooterSuccess = (espotFooter) => {
    return {
        type: actionTypes.GET_ESPOT_FOOTER_SUCCESS,
        espotFooter
    }
}

const getEspotFooterFailure = () => {
    return {
        type: actionTypes.GET_ESPOT_FOOTER_FAILURE
    }
}

const setClientSideNavigation = (clientSideNavigation) => {
    return {
        type: actionTypes.SET_CLIENT_SIDE_NAVIGATION,
        clientSideNavigation
    }
}


/* BOSS */

const setOpenModalBoss = openModalBoss => {
    return {
        type: actionTypes.OPEN_MODAL_BOSS,
        openModalBoss,
    };
};

const setPhysicalStores = physicalStores => {
    return {
        type: actionTypes.PHYSICAL_STORES,
        physicalStores,
    };
};

const setRadius = radius => {
    return {
        type: actionTypes.RADIUS,
        radius,
    };
};

const setSelectedStore = selectedStore => {
    return {
        type: actionTypes.SELECTED_STORE,
        selectedStore,
    };
};

const setClickedStore = clickedStore => {
    return {
        type: actionTypes.CLICKED_STORE,
        clickedStore,
    };
};

const setIsBossSelected = isBossSelected => {
    return {
        type: actionTypes.IS_BOSS_SELECTED,
        isBossSelected,
    };
};

const setLatitude = latitude => {
    return {
        type: actionTypes.LATITUDE,
        latitude,
    };
};

const setLongitude = longitude => {
    return {
        type: actionTypes.LONGITUDE,
        longitude,
    };
};

const setErrorBoss = errorBoss => {
    return {
        type: actionTypes.ERROR_BOSS,
        errorBoss,
    };
};